import { CSSpot_Settings } from '@websrc/Typings/ContentStack'
import clsx from 'clsx'
import React, { ReactNode } from 'react'

import { spotBackground, spotInnerSpacing } from './SpotDecoration.css'

type Props = {
  children: ReactNode
  spotSettings: CSSpot_Settings
}

export default function SpotDecoration({ children, spotSettings }: Props) {
  const backgroundColor = spotSettings?.background_color?.toLowerCase() as
    | 'none'
    | 'brand'
    | 'light'
    | 'dark'
    | 'white'
    | null
  const innerSpacing = spotSettings?.inner_spacing?.toLowerCase() as
    | 'none'
    | 'small'
    | 'standard'
    | 'large'
    | null
  return (
    <div
      className={clsx(
        backgroundColor ? spotBackground[backgroundColor] : spotBackground['none'],
        innerSpacing ? spotInnerSpacing[innerSpacing] : spotInnerSpacing['none']
      )}
    >
      {children}
    </div>
  )
}
